import React from 'react';
import ReactApexChart from 'react-apexcharts';

export default function PieChartPath() {
    const series = [70, 90, 80, 60, 40];

    const options = {
        labels: ['Dr. Shubham', 'Dr. Anita', 'Dr. Ravi', 'Dr. Rahul', 'Dr. Priya'],
        dataLabels: {
            enabled: true, // Enable labels
            formatter: function (val, opts) {
                return opts.w.config.series[opts.seriesIndex]; // Display series value
            },
        },
        
        // xaxis: {
        //     title: {
        //         text: 'Doctor Wise Test',
        //         style: {
        //             fontSize: '12px',
        //         },
        //         offsetX: -20, // Adjust the x-axis title position for RTL
        //     },
        //     labels: {
        //         style: {
        //             fontSize: '12px',
        //         },
        //         rotate: -90,
        //         // offsetX: -10, // Adjust label offset to avoid overlap with bars
        //     },
        // },
    };

    return <ReactApexChart options={options} series={series} type="pie" height={350} />;
}
